import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

import { countryCode } from 'Helpers/Geo/data';
import {
  EMAIL_SUBSCRIBE,
  EMAIL_ERROR,
  postEmail,
} from 'Redux/ducks/email-subscribe';
import store from 'Redux/store';
import 'Components/EmailSubscribe/EmailSubscribe.scss';

function EmailSubscribe({
  buttonText,
  buttonTextShort,
  context,
  auth,
  emailSubscribe,
  intl,
  label,
  parentConfirmation,
}) {
  const [email, setEmail] = useState('');

  const messages = defineMessages({
    signup: {
      id: 'emailSubscribe.buttontext',
      defaultMessage: 'Sign Up',
    },
    placeholder: {
      id: 'emailSubscribe.placeholder',
      defaultMessage: 'Enter your email',
    },
  });

  const buttonTextTranslated = buttonText || intl.formatMessage(messages.signup);
  const buttonTextShortTranslated = buttonTextShort || intl.formatMessage(messages.signup);

  const handleChange = (event) => {
    event.preventDefault();
    setEmail(event.target.value, false);
  };

  const optinEmail = (event, emailPassed, optin) => {
    event.preventDefault();
    store.dispatch(postEmail(emailPassed, context, optin, true));
    // 215 split test - let parent know user interacted
    parentConfirmation(event, true);
  };

  const handleSubmit = (event) => {
    optinEmail(event, email, true);
  };

  return (
    <div id={`emailsignup-${context}`} className="email-subscribe">
      {!auth.emailNewsletter && emailSubscribe.context === 'footer' &&
        <p className="join-email-small-text">
          <small>
            <FormattedMessage id="emailSubscribe.header" defaultMessage="Don’t miss out. Get our deals email!" />
          </small>
        </p>
      }
      {auth.emailNewsletter &&
        <React.Fragment>
          {(countryCode === 'DE') &&
            <p>
              <small>
                <FormattedMessage id="emailSubscribe.checkEmail" defaultMessage="Please check your email to confirm" />
              </small>
            </p>
          }
          {(countryCode !== 'DE') &&
            <p className="subscribed">
              <small>
                <FormattedMessage id="emailSubscribe.subscribe" defaultMessage="You’re all set to receive our emails!" />
              </small>
            </p>
          }
        </React.Fragment>
      }
      {emailSubscribe.currentState === EMAIL_SUBSCRIBE &&
        <p className="msg msg-success mb-1">
          <strong>{emailSubscribe.emailResponse}</strong>
        </p>
      }
      {emailSubscribe.currentState === EMAIL_ERROR &&
        <p className="msg msg-danger mb-1">
          <strong>{emailSubscribe.errorText}</strong>
        </p>
      }
      {(auth.authenticated) &&
        <button
          className="btn-block email-single-btn"
          onClick={event => optinEmail(event, auth.email, true)}
        >
          {buttonTextTranslated}
        </button>
      }
      {!auth.authenticated &&
        <React.Fragment>
          {label &&
            <label htmlFor="email" className="email-input-title">Email Address:</label>
          }
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                required
                placeholder={intl.formatMessage(messages.placeholder)}
                className="form-control"
                type="email"
                name="email"
                title="Enter your email address"
                enterKeyHint="send"
                aria-label="email"
                value={auth.email}
                onChange={handleChange}
              />
              <span className="input-group-append">
                <button className="btn btn-primary" type="submit">
                  {buttonTextShortTranslated}
                </button>
              </span>
            </div>
          </form>
        </React.Fragment>
      }
    </div>
  );
}

EmailSubscribe.propTypes = {
  auth: PropTypes.shape({}),
  emailSubscribe: PropTypes.shape({}),
  buttonText: PropTypes.string,
  buttonTextShort: PropTypes.string,
  context: PropTypes.string,
  label: PropTypes.bool,
  parentConfirmation: PropTypes.func,
};

EmailSubscribe.defaultProps = {
  auth: {},
  emailSubscribe: {},
  buttonText: '',
  buttonTextShort: '',
  context: '',
  label: false,
  parentConfirmation: () => {},
};

const mapStateToProps = ({
  auth,
  emailSubscribe,
}) => ({
  auth,
  emailSubscribe,
});

export default connect(mapStateToProps)(injectIntl(EmailSubscribe));
